import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NewsService } from '../../../services/news.service';
import { NewsItem } from '../../../interfaces/news.interface';

@Component({
  selector: 'app-ai-startup',
  templateUrl: './ai-startup.component.html',
  styleUrls: ['./ai-startup.component.scss']
})
export class AiStartupComponent implements OnInit {

  selectedFaqIndex: number | null = null;
  newsItems: NewsItem[] = [];

  faqs = [
    {
      question: 'What is RingPilot and how can it benefit my business?',
      answer: 'RingPilot is an advanced cloud-based contact center platform that automates and streamlines your communication processes. It helps businesses increase outreach efficiency, improve customer engagement, and boost sales by providing powerful dialing, CRM integration, and omnichannel communication tools—all designed to enhance productivity and customer satisfaction.'
    },
    {
      question: "How does RingPilot's dialer improve sales productivity?",
      answer: "RingPilot's dialer automates the calling process using multiple dialing modes like power, predictive, and preview dialing. This reduces manual dialing time, connects agents only to live contacts, and optimizes call pacing based on agent availability—allowing your sales team to make more calls, engage more prospects, and close more deals in less time."
    },
    {
      question: 'How does RingPilot ensure data security and compliance?',
      answer: 'RingPilot prioritizes security with end-to-end encryption, PCI DSS compliance, and certifications such as ISO 27001 and ISO 27018. Our platform undergoes regular vulnerability assessments, continuous security monitoring, and strict adherence to industry standards to protect your data and ensure compliance with regulations like GDPR, HIPAA, and TCPA.'
    },
    {
      question: 'Is there a free trial or demo available before purchasing?',
      answer: "Yes! RingPilot offers a free demo and trial period so you can experience our platform's features and benefits firsthand. Our team will guide you through setup and answer any questions to ensure RingPilot is the right fit for your business needs."
    },
    {
      question: 'What reporting and analytics capabilities does RingPilot provide?',
      answer: 'RingPilot offers comprehensive, real-time reporting and analytics dashboards that track campaign performance, agent productivity, call outcomes, conversion rates, and customer satisfaction scores. Customizable reports help you identify trends, optimize workflows, and make data-driven decisions to continually improve your contact center operations.'
    },
    {
      question: 'Can RingPilot be used remotely or in a work-from-home setup?',
      answer: 'Absolutely. RingPilot is a cloud-based solution designed for complete location independence. Agents and supervisors can access the platform securely from any device or browser, enabling seamless remote work, real-time monitoring, and uninterrupted business continuity regardless of physical location.'
    }
  ];

  toggleFaq(index: number) {
    this.selectedFaqIndex = this.selectedFaqIndex === index ? null : index;
  }
  
  @ViewChild('contactModal') contactModal: ElementRef;

  public contactForm: FormGroup;
  public isposted:number=0;
  public submitted:boolean=false;

  get f() {
    return this.contactForm.controls;
  }

  constructor(
    private titleService: Title, 
    private metaService: Meta, 
    private fb: FormBuilder, 
    protected http: HttpClient,
    private newsService: NewsService
  ) { 
    this.contactForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      phone_number: ['', Validators.required],      
      message: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Set the title
    this.http.get(environment.apiUrl + '/home').subscribe(
      (response: any) => {
        if (response.metaTags) {
          this.updateMetaTags(response.metaTags);
        }
      },
      (error) => {
        console.error('Error fetching meta tags:', error);
        // Fallback to default meta tags if API call fails
        this.titleService.setTitle('RingPilot - AI-Powered Communication Solutions for Startups');
        this.metaService.updateTag({ name: 'description', content: 'Transform your startup\'s communication with RingPilot\'s AI-powered solutions. Enhance customer engagement, streamline operations, and scale your business with our innovative platform.' });
        this.metaService.updateTag({ name: 'keywords', content: 'RingPilot, AI communication, startup solutions, cloud contact center, customer engagement, business communication' });
      }
    );

    // Load latest news
    this.loadLatestNews();
  }

  loadLatestNews(): void {
    this.newsService.getLatestNews().subscribe(
      (newsItems) => {
        this.newsItems = newsItems;
        console.log(this.newsItems);
      },
      (error) => {
        console.error('Error loading latest news:', error);
      }
    );
  }

  onSubmit(): void {
    
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }

    console.log(this.contactForm.value)

    let cdata = JSON.stringify(this.contactForm.value);

  }

  closeModal() {
    const modalElement = this.contactModal.nativeElement;
    modalElement.classList.remove('show');
    modalElement.style.display = 'none';
    modalElement.setAttribute('aria-hidden', 'true');
    modalElement.removeAttribute('aria-modal');
    modalElement.removeAttribute('role');
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.remove();
    }
  }

  Close(){
    this.isposted=0;
  }

  @ViewChild('cardContainer', { static: false }) cardContainer!: ElementRef;

  scrollCards(direction: number) {
    const scrollAmount = 320;
    this.cardContainer.nativeElement.scrollLeft += direction * scrollAmount;
  }

  private updateMetaTags(metaTags: any[]): void {
    // Remove existing meta tags
    this.metaService.removeTag("name='description'");
    this.metaService.removeTag("name='keywords'");
    this.metaService.removeTag("name='author'");
    this.metaService.removeTag("property='og:title'");
    this.metaService.removeTag("property='og:description'");
    this.metaService.removeTag("property='og:image'");
    this.metaService.removeTag("property='og:url'");
    this.metaService.removeTag("property='og:type'");
    this.metaService.removeTag("name='twitter:card'");
    this.metaService.removeTag("name='twitter:title'");
    this.metaService.removeTag("name='twitter:description'");
    this.metaService.removeTag("name='twitter:image'");
    this.metaService.removeTag("rel='canonical'");

    // Add new meta tags
    metaTags.forEach(tag => {
      if (tag.name === 'title') {
        this.titleService.setTitle(tag.content);
      } else if (tag.charset) {
        this.metaService.updateTag({ charset: tag.charset });
      } else if (tag['http-equiv']) {
        this.metaService.updateTag({ 'http-equiv': tag['http-equiv'], content: tag.content });
      } else if (tag.rel === 'canonical') {
        this.metaService.updateTag({ rel: 'canonical', href: tag.href });
      } else {
        const metaTag: any = {};
        if (tag.name) metaTag.name = tag.name;
        if (tag.property) metaTag.property = tag.property;
        if (tag.content) metaTag.content = tag.content;
        this.metaService.updateTag(metaTag);
      }
    });
  }

  cards = [
    {
      icon: 'bi-speedometer2',
      title: 'Unified Operations',
      text: 'Integrating dialer software with your existing systems creates a cohesive ecosystem, streamlining operations and improving overall efficiency.'
    },
    {
      icon: 'bi-people-fill',
      title: 'Enhanced Customer Insights',
      text: 'Integration with CRM and databases offers a comprehensive view of customer interactions for more personalized and effective communication.'
    },
    {
      icon: 'bi-bar-chart-line-fill',
      title: 'Improved Agent Performance',
      text: 'Real-time access to customer data empowers agents to provide better service and resolve issues quickly, boosting efficiency.'
    },
    {
      icon: 'bi-database-fill-gear',
      title: 'Centralized Data Management',
      text: 'All data is centralized, making it easier to manage, analyze, and use for strategic decisions and accurate insights.'
    },
    {
      icon: 'bi-diagram-3-fill',
      title: 'Seamless Workflows',
      text: 'Integrated dialer software reduces manual data entry, minimizes errors, and enhances workflow efficiency.'
    },
    {
      icon: 'bi-graph-up-arrow',
      title: 'Better Reporting',
      text: 'Comprehensive reports provide deeper insights into performance metrics and highlight areas for improvement.'
    },
    {
      icon: 'bi-arrows-move',
      title: 'Increased Flexibility',
      text: 'Integration enables quick adaptation to business changes, ensuring agility and responsiveness in the market.'
    }
  ];

  items = [
  {
    title: 'Maximize Productivity',
    content: 'Call center dialers automate the dialing process, allowing agents to focus on live interactions rather than manual dialing. This boosts productivity and ensures more calls are made in less time.',
    link: '/blogs/dialer-productivity'
  },
  {
    title: 'Enhance Customer Experience',
    content: 'By reducing wait times and ensuring faster connections, call center dialers significantly improve the customer experience, leading to higher satisfaction and loyalty.',
    link: '/blogs/customer-experience'
  },
  {
    title: 'Scalable Solutions',
    content: 'As your business grows, call center dialers can easily scale to accommodate increased call volumes and additional agents, ensuring seamless expansion.',
    link: '/blogs/business-scalability'
  },
  {
    title: 'Regulatory Compliance',
    content: 'Modern dialers are equipped with features to ensure compliance with industry regulations, protecting your business from legal issues and maintaining customer trust.',
    link: '/blogs/business-compliance'
  },
  {
    title: 'Data-Driven Insights',
    content: 'Integrated analytics provide real-time data on call performance, agent efficiency, and customer interactions. This helps businesses make informed decisions and continuously improve their operations.',
    link: '/blogs/dialer-data-insights'
  }
];

items2 = [
  {
    title: 'Minimized Idle Time',
    content: 'Predictive and AI-driven dialers optimize call timing, reducing agent idle time and ensuring they are always engaged in productive activities.',
    link: '/blogs/dialer-idle-time'
  },
  {
    title: 'Streamlined Campaign Management',
    content: 'Manage multiple campaigns effortlessly with features that allow for easy switching and monitoring, ensuring each campaign runs smoothly and effectively.',
    link: '/blogs/dialer-campaign-management'
  },
  {
    title: 'Enhanced Workforce Management',
    content: 'Tools like agent performance dashboards and manager panels provide better oversight and management capabilities, ensuring high performance and quick identification of training needs.',
    link: '/blogs/business-workforce-management'
  },
  {
    title: 'Secure Communications',
    content: 'Advanced security features ensure that all communications and data are protected, maintaining the integrity and confidentiality of customer information.',
    link: '/blogs/business-security'
  },
  {
    title: 'Cost Efficiency',
    content: 'Automation reduces the need for extensive manual labor, lowering operational costs and allowing businesses to manage higher call volumes without additional staffing.',
    link: '/blogs/business-cost-efficiency'
  }
];

selectedIndex: number | null = null;
selectedIndex2: number | null = null;

toggleAccordion(index: number): void {
  this.selectedIndex = this.selectedIndex === index ? null : index;
}

toggleAccordion2(index: number): void {
  this.selectedIndex2 = this.selectedIndex2 === index ? null : index;
}


}
